// extracted by mini-css-extract-plugin
module.exports = {"markdown":"Markdown_markdown__QZ95j","placeholder":"Markdown_placeholder__KGmpO"};